// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"feb839a1","727":"16f6ba72","917":"fd015ea2"}[chunkId] + ".chunk.js";
};